module.exports = __webpack_public_path__ + "img/qrCodeDoacao.09a104e6.png";